/**
 * Foundation endpoint groups. Split by owner (plan §7.5.4): `session.ts` (auth), `metadata.ts`
 * and `records.ts` are re-exported here unchanged; health, nav and directory are the reference
 * conversions to typed contracts (`@dataroom/contracts/<area>`) and call them through `call`.
 */
import { directoryMembersContract } from '@dataroom/contracts/directory';
import { healthContract } from '@dataroom/contracts/health';
import { navContract } from '@dataroom/contracts/nav';
import type { Http } from './http';
import { createCall } from './typed';

export * from './session';
export * from './metadata';
export * from './records';

export const healthApi = (http: Http) => {
  const call = createCall(http);
  return { get: () => call(healthContract) };
};

export const navApi = (http: Http) => {
  const call = createCall(http);
  return { get: () => call(navContract) };
};

export const directoryApi = (http: Http) => {
  const call = createCall(http);
  return {
    members: (status: 'active' | 'all' = 'active') => call(directoryMembersContract, { query: { status } }),
  };
};
